module.exports = __webpack_public_path__ + "static/media/app_store_en.2df43957.svg";